export const CHANGE_UI_STATE = "CHANGE_UI_STATE";
export const CHANGE_TEMP_DATA = "CHANGE_TEMP_DATA";
export const CLEAR_STATE = "CLEAR_STATE";
export const SETTING_LANGUAGE = "SETTING_LANGUAGE";



/** WEBPACK FOOTER **
 ** ./src/constants/actionTypes.js
 **/